import _ from "lodash";
import {
    CONDITION_YES_NO_FIELDS,
    CONTAMINATION_FIELDS,
    DECLARATION_ACCEPTED_FIELD,
    REASON_YES_NO_FIELDS,
    RUNNING_TIME_HOURS_FIELD,
    SectionKey,
    SUBSTANCES_FIELD,
} from "./fields";

export interface CatalogAttribute {
    index: string;
    name: string;
    type?: string | null;
    inputType?: string | null;
    hint?: string | null;
    categories?: Array<string | null> | null;
    rules?: Array<{ name?: string | null; message?: string | null } | null> | null;
    optionValues?: Array<{ name?: string | null; value?: string | null } | null> | null;
    value?: unknown;
}

const REQUIRED = [{ name: 'required' }];

// Section → question mapping of the global template (backend handoff §6). Used
// only when a declaration arrives without its TDA catalog, so the editor never
// renders an empty shell; labels are start-cased indices in that case.
const FALLBACK_SECTIONS: Array<[SectionKey, Array<[string, boolean]>]> = [
    ['descriptionOfEquipment', [[RUNNING_TIME_HOURS_FIELD, false], ['invoiceNumber', false], ['purchaseOrderNumber', false]]],
    ['reasonForService', [
        ['reasonForService', true],
        ...REASON_YES_NO_FIELDS.map((f): [string, boolean] => [f, true]),
    ]],
    ['conditionOfEquipment', [
        ...CONDITION_YES_NO_FIELDS.map((f): [string, boolean] => [f, true]),
        ['oilType', false],
    ]],
    ['contamination', CONTAMINATION_FIELDS.map((f): [string, boolean] => [f, true])],
    // The substances table is required since Rev. 2 - the form asks for it "even
    // if only air exposure", so naming none is not an answer.
    ['harmfulSubstances', [[SUBSTANCES_FIELD, true], ['substancesAdditionalInformation', false]]],
    ['contactInformation', [['billingAddress', true], ['shippingAddress', true], ['technicianName', true], ['technicianPhone', false], ['technicianEmail', false]]],
    ['legallyBindingDeclaration', [[DECLARATION_ACCEPTED_FIELD, true]]],
];

export const getFallbackCatalog = (): CatalogAttribute[] =>
    FALLBACK_SECTIONS.flatMap(([section, fields]) =>
        fields.map(([index, required]) => ({
            index,
            name: _.startCase(index),
            categories: [section],
            rules: required ? REQUIRED : [],
        })),
    );

/** Mirrors TDAForm's label rule: the name plus " *" when a `required` rule exists. */
export const getAttributeLabel = (attribute: CatalogAttribute): string =>
    isAttributeRequired(attribute) ? `${attribute.name} *` : attribute.name;

export const isAttributeRequired = (attribute: CatalogAttribute): boolean =>
    !!attribute.rules?.some((rule) => rule?.name === 'required');
